/**
 * Переводы для VoiceWidget
 *
 * Поддерживаемые языки: en, ru, nl (Dutch для Amsterdam), а также fr, de,
 * lu, el — языки витрины (#1417). Язык передаёт только витрина (`App.jsx`),
 * дилерский `mount()` его не передаёт, и там виджет остаётся на английском.
 */

export const translations = {
  en: {
    // Voice statuses
    connecting: 'Connecting',
    reconnecting: 'Reconnecting',
    listening: 'Listening',
    speaking: 'Speaking',
    typing: 'Typing',
    // Other UI
    endConversation: 'End conversation',
    startVoice: 'Start voice conversation',
    openChat: 'Open chat',
    typeMessage: 'Type a message',
    // Строка согласия, кнопки и подписи чата (#1431).
    consentPrefix: 'By using this chat, you agree to',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    sendMessage: 'Send message',
    switchToVoice: 'Switch to voice mode',
    switchToChat: 'Switch to chat mode',
    poweredBy: 'Powered by',
    askAi: 'Ask AI',
  },
  ru: {
    // Voice statuses
    connecting: 'Подключение',
    reconnecting: 'Переподключение',
    listening: 'Слушаю',
    speaking: 'Говорит',
    typing: 'Печатает',
    // Other UI
    endConversation: 'Завершить разговор',
    startVoice: 'Начать голосовой разговор',
    openChat: 'Открыть чат',
    typeMessage: 'Введите сообщение',
    // Строка согласия, кнопки и подписи чата (#1431).
    consentPrefix: 'Используя этот чат, вы соглашаетесь с',
    termsOfService: 'Условиями использования',
    and: 'и',
    privacyPolicy: 'Политикой конфиденциальности',
    sendMessage: 'Отправить сообщение',
    switchToVoice: 'Перейти в голосовой режим',
    switchToChat: 'Перейти в чат',
    poweredBy: 'Работает на',
    askAi: 'Спросить ИИ',
  },
  nl: {
    // Voice statuses
    connecting: 'Verbinden',
    reconnecting: 'Opnieuw verbinden',
    listening: 'Luisteren',
    speaking: 'Spreken',
    typing: 'Aan het typen',
    // Other UI
    endConversation: 'Gesprek beëindigen',
    startVoice: 'Start spraakgesprek',
    openChat: 'Chat openen',
    typeMessage: 'Typ een bericht',
    // Строка согласия, кнопки и подписи чата (#1431).
    consentPrefix: 'Door deze chat te gebruiken, ga je akkoord met de',
    termsOfService: 'Gebruiksvoorwaarden',
    and: 'en het',
    privacyPolicy: 'Privacybeleid',
    sendMessage: 'Bericht versturen',
    switchToVoice: 'Naar spraakmodus',
    switchToChat: 'Naar chatmodus',
    poweredBy: 'Mogelijk gemaakt door',
    askAi: 'Vraag AI',
  },
  fr: {
    connecting: 'Connexion',
    reconnecting: 'Reconnexion',
    listening: "À l'écoute",
    speaking: 'Parle',
    typing: 'Écrit',
    endConversation: 'Terminer la conversation',
    startVoice: 'Démarrer une conversation vocale',
    openChat: 'Ouvrir le chat',
    typeMessage: 'Écrivez un message',
    // Строка согласия, кнопки и подписи чата (#1431).
    consentPrefix: 'En utilisant ce chat, vous acceptez les',
    termsOfService: "Conditions d'utilisation",
    and: 'et la',
    privacyPolicy: 'Politique de confidentialité',
    sendMessage: 'Envoyer le message',
    switchToVoice: 'Passer en mode vocal',
    switchToChat: 'Passer en mode chat',
    poweredBy: 'Propulsé par',
    askAi: "Demander à l'IA",
  },
  de: {
    connecting: 'Verbinden',
    reconnecting: 'Neu verbinden',
    listening: 'Hört zu',
    speaking: 'Spricht',
    typing: 'Schreibt',
    endConversation: 'Gespräch beenden',
    startVoice: 'Sprachgespräch starten',
    openChat: 'Chat öffnen',
    typeMessage: 'Nachricht schreiben',
    // Строка согласия, кнопки и подписи чата (#1431).
    consentPrefix: 'Mit der Nutzung dieses Chats akzeptieren Sie die',
    termsOfService: 'Nutzungsbedingungen',
    and: 'und die',
    privacyPolicy: 'Datenschutzerklärung',
    sendMessage: 'Nachricht senden',
    switchToVoice: 'Zum Sprachmodus wechseln',
    switchToChat: 'Zum Chat wechseln',
    poweredBy: 'Bereitgestellt von',
    askAi: 'KI fragen',
  },
  lu: {
    connecting: 'Verbannen',
    reconnecting: 'Nei verbannen',
    listening: 'Lauschtert',
    speaking: 'Schwätzt',
    typing: 'Schreift',
    endConversation: 'Gespréich ofschléissen',
    startVoice: 'Stëmmgespréich starten',
    openChat: 'Chat opmaachen',
    typeMessage: 'Message schreiwen',
    // Строка согласия, кнопки и подписи чата (#1431).
    consentPrefix: 'Andeems Dir dëse Chat benotzt, akzeptéiert Dir',
    termsOfService: "d'Notzungsbedéngungen",
    and: 'an',
    privacyPolicy: "d'Dateschutzerklärung",
    sendMessage: 'Message schécken',
    switchToVoice: 'An de Stëmmmodus wiesselen',
    switchToChat: 'An de Chat wiesselen',
    poweredBy: 'Ënnerstëtzt vun',
    askAi: 'KI froen',
  },
  el: {
    connecting: 'Σύνδεση',
    reconnecting: 'Επανασύνδεση',
    listening: 'Ακούει',
    speaking: 'Μιλάει',
    typing: 'Πληκτρολογεί',
    endConversation: 'Τέλος συνομιλίας',
    startVoice: 'Έναρξη φωνητικής συνομιλίας',
    openChat: 'Άνοιγμα συνομιλίας',
    typeMessage: 'Γράψτε ένα μήνυμα',
    // Строка согласия, кнопки и подписи чата (#1431).
    consentPrefix: 'Χρησιμοποιώντας αυτή τη συνομιλία, αποδέχεστε τους',
    termsOfService: 'Όρους χρήσης',
    and: 'και την',
    privacyPolicy: 'Πολιτική απορρήτου',
    sendMessage: 'Αποστολή μηνύματος',
    switchToVoice: 'Μετάβαση σε φωνητική λειτουργία',
    switchToChat: 'Μετάβαση σε συνομιλία',
    poweredBy: 'Με την υποστήριξη του',
    askAi: 'Ρωτήστε την ΤΝ',
  },
};

/**
 * Получить перевод по ключу
 * @param {string} key - ключ перевода
 * @param {string} lang - язык ('en', 'ru', 'nl', 'fr', 'de', 'lu', 'el')
 * @returns {string} переведенная строка
 */
export function t(key, lang = 'en') {
  return translations[lang]?.[key] || translations.en[key] || key;
}
